import {toggleSpinner} from "../global/utilities";

jQuery(document).ready(function ($) {
    const $lostPasswordLink = $('.elementor-lost-password');
    const $signupLink = $('.elementor-not-yet-signup');
    const $lostPasswordOverlay = $('.lost-password-overlay');
    const $lostPasswordEmail = $('#lost-password-email');
    const $submitResetPassword = $('.submit-reset-password');
    const $closeResetPassword = $('.close-reset-password');
    const $lostPasswordMessage = $('.lost-password-message');
    const $toggleShowPassword = $('.visibility-toggle');
    const $password = $('#password');

    $lostPasswordLink.data('href', $lostPasswordLink.attr('href'));
    $signupLink.data('href', $signupLink.attr('href'));

    $lostPasswordLink.on('click', () => {
        if (!$lostPasswordLink.attr('href')) {
            return;
        }

        $lostPasswordOverlay.addClass('active');
    });

    $toggleShowPassword.on('click', () => {
        $toggleShowPassword.toggleClass("fa-eye fa-eye-slash");

        if($password.attr('type') === 'password') {
            $password.attr('type', 'text');
        }
        else {
            $password.attr('type', 'password');
        }
    });

    $closeResetPassword.on('click', () => {
        $lostPasswordOverlay.removeClass('active');
    });

    $submitResetPassword.on('click', () => {
        if (!$lostPasswordEmail.is(':valid')) {
            return;
        }

        toggleSpinner($submitResetPassword[0], true);

        jQuery.post(ajax_object.ajax_url, {
            action: 'reset_password',
            email: $lostPasswordEmail.val(),
        }, 'json')
            .always(function (data, textStatus, jqXHR) {
                $lostPasswordMessage.html(`
                    <p>
                        ${data.data.message}
                    </p>
                `);

                $lostPasswordMessage.addClass('active');
                toggleSpinner($submitResetPassword[0], false);
            });
    });

    $lostPasswordEmail.on('input', () => {
        $submitResetPassword.attr('disabled', !$lostPasswordEmail.is(':valid'));
    });

    // If username or password is empty, disable the submit button
    $('#login-form input').on('input', function () {
        const username = $('#username').val();
        const password = $('#password').val();

        if (username && password) {
            $('#login-form button[type="submit"]').prop('disabled', false);
        } else {
            $('#login-form button[type="submit"]').prop('disabled', true);
        }
    });

    $('#login-form button[type="submit"]').on('click', function (e) {
        e.preventDefault();

        toggleSpinner(this, true);

        $lostPasswordLink.removeAttr('href');
        $signupLink.removeAttr('href');

        const username = $('#username').val();
        const password = $('#password').val();
        const error_element = $('.error');

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'user_login',
                username: username,
                password: password,
            },
            success: function (response) {
                if (response.success) {
                    setAuthCookie({
                        access_token: response.data.access_token,
                        token_type: "Bearer",
                        scope: response.data.scope,
                        refresh_token: response.data.refresh_token,
                        expires_in: response.data.expires_in
                    });
                    window.location.reload()
                } else {
                    error_element.show()
                    error_element.find('p span').html("Une erreur s'est produite");

                    toggleSpinner(document.querySelector('#login-form button'), false);

                    $lostPasswordLink.attr('href', $lostPasswordLink.data('href'));
                    $signupLink.attr('href', $signupLink.data('href'));
                }
            },
            error: function () {
                alert('An error occurred. Please try again.');
            },
        });
    });
});

function setAuthCookie(data) {
    const {access_token, token_type, scope, refresh_token, expires_in} = data;

    // Calculate the expiration date
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + expires_in * 1000);

    // Combine all data into a single object
    const authData = {
        access_token,
        token_type,
        scope,
        refresh_token,
        expires_in,
    };

    // Set a single cookie with serialized JSON data
    document.cookie = `resamania_auth=${encodeURIComponent(JSON.stringify(authData))}; expires=${expirationDate.toUTCString()}; path=/; secure`;
}
